module.exports = __webpack_public_path__ + "img/accept-terms-rafiki.54fc25da.svg";